var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("sc-form", {
    attrs: { form: _vm.cteUploadForm, rules: _vm.rules },
    on: { submit: _vm.uploadCTeFile },
    scopedSlots: _vm._u([
      {
        key: "fields",
        fn: function(ref) {
          var fields = ref.fields
          return [
            _c("div", { staticClass: "columns" }, [
              _c(
                "div",
                { staticClass: "column" },
                [
                  _c("span", { staticClass: "sc-label-bigger" }, [
                    _vm._v("Escolha a transportadora")
                  ]),
                  _vm._v(" "),
                  _c(
                    "sc-field",
                    {
                      attrs: {
                        label: "Transportadora",
                        prop: "logisticProviderId",
                        expanded: ""
                      }
                    },
                    [
                      _c("sc-logistic-provider-dropdown", {
                        on: {
                          input: function($event) {
                            _vm.clearFieldsForCorreios(fields)
                          }
                        },
                        model: {
                          value: fields.logisticProviderId,
                          callback: function($$v) {
                            _vm.$set(fields, "logisticProviderId", $$v)
                          },
                          expression: "fields.logisticProviderId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: fields.logisticProviderId !== 1,
                      expression: "fields.logisticProviderId !== 1"
                    }
                  ],
                  staticClass: "column"
                },
                [
                  _c("span", { staticClass: "sc-label-bigger" }, [
                    _vm._v("Faça o upload dos arquivos CT-e")
                  ]),
                  _vm._v(" "),
                  _c(
                    "sc-field",
                    {
                      attrs: {
                        label: "Arquivo nos formatos .zip ou .rar",
                        prop: "ctesFiles",
                        expanded: ""
                      }
                    },
                    [
                      _c(
                        "sc-files-upload",
                        _vm._b(
                          {
                            ref: "ctesFilesUpload",
                            on: {
                              addfilestart: function(file) {
                                return (fields.ctesFiles = file)
                              },
                              removefile: function() {
                                return (fields.ctesFiles = null)
                              }
                            }
                          },
                          "sc-files-upload",
                          _vm.fileImporterOptions,
                          false
                        )
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]
        }
      },
      {
        key: "actions",
        fn: function(ref) {
          var isValid = ref.isValid
          return [
            _c(
              "router-link",
              {
                staticClass: "button",
                attrs: { to: { name: "pre-invoice-audit" } }
              },
              [_vm._v("\n      Voltar\n    ")]
            ),
            _vm._v(" "),
            _c("sc-button", {
              attrs: { text: "Enviar CT-e", type: "submit", theme: "primary" }
            })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-104c7f62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-104c7f62","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/cte-upload/components/sc-cte-upload-form/ScCteUploadForm.vue
// module id = null
// module chunks = 